export default __webpack_public_path__ + "static/media/seller_invoice.6151d027.xlsx";